var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "fields-wrapper" }, [
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "charname" }
              },
              [_vm._v("Character Selector")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.selectedModel,
                      expression: "inputData.selectedModel"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { placeholder: "Character Selector", id: "charname" },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.inputData,
                          "selectedModel",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function($event) {
                        return _vm.changeSelectedModel($event)
                      }
                    ]
                  }
                },
                _vm._l(_vm.fbxModels, function(model, key) {
                  return _c("option", { key: key, domProps: { value: key } }, [
                    _vm._v(_vm._s(model.name))
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "start_time" }
              },
              [_vm._v("\n            Start Time\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.startTime,
                    expression: "inputData.startTime"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "start_time" },
                domProps: { value: _vm.inputData.startTime },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.inputData, "startTime", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "end_time" }
              },
              [_vm._v("\n            End Time\n          ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.endTime,
                    expression: "inputData.endTime"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", id: "end_time" },
                domProps: { value: _vm.inputData.endTime },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.inputData, "endTime", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-5 col-form-label",
                attrs: { for: "presentation_duration" }
              },
              [_vm._v("Presence Duration (sec)")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-7" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.presenceDuration,
                    expression: "inputData.presenceDuration"
                  }
                ],
                staticClass: "form-control",
                style: _vm.errorPresenceDuration && {
                  boxShadow: "0 0 0 0.2rem red"
                },
                attrs: {
                  type: "text",
                  readonly: "",
                  id: "presentation_duration"
                },
                domProps: { value: _vm.inputData.presenceDuration },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.inputData,
                      "presenceDuration",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-4 col-form-label",
                attrs: { for: "polygon_count" }
              },
              [_vm._v("Polygon Count")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputData.polygonCount,
                    expression: "inputData.polygonCount"
                  }
                ],
                staticClass: "form-control",
                attrs: { readonly: "", type: "text", id: "polygon_count" },
                domProps: { value: _vm.inputData.polygonCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.inputData, "polygonCount", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("Position of Origin")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.positionOfOrigin.x,
                      expression: "inputData.positionOfOrigin.x"
                    }
                  ],
                  staticClass: "form-control border-danger",
                  attrs: {
                    type: "number",
                    id: "position_of_the_origin_x",
                    step: "0.01"
                  },
                  domProps: { value: _vm.inputData.positionOfOrigin.x },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.positionOfOrigin,
                        "x",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.positionOfOrigin.y,
                      expression: "inputData.positionOfOrigin.y"
                    }
                  ],
                  staticClass: "form-control  border-success",
                  attrs: {
                    type: "number",
                    id: "position_of_the_origin_y",
                    step: "0.01"
                  },
                  domProps: { value: _vm.inputData.positionOfOrigin.y },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.positionOfOrigin,
                        "y",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.positionOfOrigin.z,
                      expression: "inputData.positionOfOrigin.z"
                    }
                  ],
                  staticClass: "form-control border-secondary border-2",
                  attrs: {
                    type: "number",
                    id: "position_of_the_origin_z",
                    step: "0.01"
                  },
                  domProps: { value: _vm.inputData.positionOfOrigin.z },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.positionOfOrigin,
                        "z",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-4 col-form-label" }, [
              _vm._v("Rotation of Origin")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.rotationOfOrigin.x,
                      expression: "inputData.rotationOfOrigin.x"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    id: "rotation_of_the_origin_x",
                    step: "0.01"
                  },
                  domProps: { value: _vm.inputData.rotationOfOrigin.x },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.rotationOfOrigin,
                        "x",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.rotationOfOrigin.y,
                      expression: "inputData.rotationOfOrigin.y"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    id: "rotation_of_the_origin_y",
                    step: "0.01"
                  },
                  domProps: { value: _vm.inputData.rotationOfOrigin.y },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.rotationOfOrigin,
                        "y",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.rotationOfOrigin.z,
                      expression: "inputData.rotationOfOrigin.z"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "number",
                    id: "rotation_of_the_origin_z",
                    step: "0.01"
                  },
                  domProps: { value: _vm.inputData.rotationOfOrigin.z },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.rotationOfOrigin,
                        "z",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("div", { staticClass: "fields-wrapper" }, [
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-6 col-form-label" }, [
              _vm._v("Scale (in meters)")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-8" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputData.scale,
                        expression: "inputData.scale"
                      }
                    ],
                    attrs: { type: "range", min: "0", max: "1", step: "0.01" },
                    domProps: { value: _vm.inputData.scale },
                    on: {
                      __r: function($event) {
                        return _vm.$set(
                          _vm.inputData,
                          "scale",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputData.scale,
                        expression: "inputData.scale"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number", step: "0.01", max: "1", min: "0" },
                    domProps: { value: _vm.inputData.scale },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.inputData, "scale", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "col-4" }, [
                  _vm._v(_vm._s(_vm.inputData.scale))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c("label", { staticClass: "col-sm-6 col-form-label" }, [
              _vm._v("Dimensions (meters)")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.dimensions.x,
                      expression: "inputData.dimensions.x"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "", type: "text", id: "dimensions_x" },
                  domProps: { value: _vm.inputData.dimensions.x },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.dimensions,
                        "x",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.dimensions.y,
                      expression: "inputData.dimensions.y"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "", type: "text", id: "dimensions_y" },
                  domProps: { value: _vm.inputData.dimensions.y },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.dimensions,
                        "y",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.dimensions.z,
                      expression: "inputData.dimensions.z"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "", type: "text", id: "dimensions_z" },
                  domProps: { value: _vm.inputData.dimensions.z },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.inputData.dimensions,
                        "z",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _c(
              "label",
              { staticClass: "col-sm-6 col-form-label", attrs: { for: "rig" } },
              [_vm._v("Rig Type")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.rigType,
                      expression: "inputData.rigType"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "rig", readonly: "" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.inputData,
                        "rigType",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "Humanoid" } }, [
                    _vm._v("Humanoid")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "Custom" } }, [
                    _vm._v("Custom")
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.material,
                      expression: "inputData.material"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "materials" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.inputData,
                        "material",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", [_vm._v("Select Material")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("Link 1")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("Link 2")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("Link 3")])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group align-items-center" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputData.interactiveSurface,
                      expression: "inputData.interactiveSurface"
                    }
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "interactive_surfaces" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.inputData,
                        "interactiveSurface",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", [_vm._v("Select Interactive Surfaces")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("Link 1")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("Link 2")]),
                  _vm._v(" "),
                  _c("option", [_vm._v("Link 3")])
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-flex align-items-center" }, [
      _c("h4", [_vm._v("Character")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-4" }, [
        _c("div", { staticClass: "row form-group align-items-center" }, [
          _c("div", { staticClass: "col-sm-12" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "col-sm-6 col-form-label", attrs: { for: "materials" } },
      [
        _vm._v("\n            Materials\n            "),
        _c("i", { staticClass: "fas fa-times text-danger ml-2" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "col-sm-6 col-form-label",
        attrs: { for: "interactive_surfaces" }
      },
      [
        _vm._v("\n            Interactive Surfaces\n            "),
        _c("i", { staticClass: "fas fa-times text-danger ml-2" })
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d847232", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d847232","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/character/maininspector.vue
// module id = null
// module chunks = 